// 登录
import service from '@/utils/request'
// 通讯录--名片列表
export function cardlist (data) {
  return service({
    url: '/service/admin/cardlist',
    method: 'post',
    params: data
  })
}
export function cardview (data) {
  return service({
    url: '/service/admin/card_view',
    method: 'post',
    params: data
  })
}
export function cardSetverifystatus (data) {
  return service({
    url: '/service/admin/card_setverifystatus',
    method: 'post',
    params: data
  })
}
export function cardSetstatus (data) {
  return service({
    url: '/service/admin/card_setstatus',
    method: 'post',
    params: data
  })
}
export function cardIstoprecord (data) {
  return service({
    url: '/service/admin/card_istoprecord',
    method: 'post',
    params: data
  })
}
